import { createSelector } from 'reselect';

export const getComponentState = state => state.department;

export const getProducts = createSelector(
    getComponentState,
    (state) => state.products
);
export const getFetching = createSelector(
    getComponentState,
    (state) => state.fetching
);
export const getDepartment = createSelector(
    getComponentState,
    (state) => state.department
);
export const getFetchingDepartment = createSelector(
    getComponentState,
    (state) => state.fetchingDepartment
);
export const getProductType = createSelector(
    getComponentState,
    (state) => state.productType
);